module.exports = __webpack_public_path__ + "img/dsc-5293.895dca4a.jpg";